
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/welciaCouponCampaign",
      function () {
        return require("private-next-pages/welciaCouponCampaign.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/welciaCouponCampaign"])
      });
    }
  